<img src="assets/images/construction.webp" loading="lazy">